<app-three-column-template
  [customDateField]="customDateField()"
  [hasCustomMain]="true"
  [pageData]="pageData()"
  [showTags]="showTags()">

  <app-side-navigation
    [pageData]="pageData()"
    [customNavigation]="customNavigation()"
    slot="left-section"></app-side-navigation>
  <app-breadcrumbs
    [pageData]="pageData()"
    slot="breadcrumb-section"></app-breadcrumbs>

  @if (pageData().showContents) {
    <app-toc></app-toc>
  }

  @if (pageData()?.summary && pageData().type !== E_FOLDER_TYPES.Folder) {
    <app-ck-viewer [htmlDescription]="pageData()?.summary"></app-ck-viewer>
  }
  <app-ck-viewer [fullBody]="true"
                 [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>

  @if (pageData() && HELPER.FF.collections) {
    <app-collections [pageData]="pageData()"/>
  }

  <app-viewlet [pageData]="pageData()"></app-viewlet>

  <app-related-items
    [noBottomPadding]="true"
    [pageData]="pageData()"></app-related-items>

  @if (pageData() && isProjectFolder() && pageData()?.relatedDiscussions?.length) {
    <app-horizontal-divider></app-horizontal-divider>
    <div class="related-publications">
      <div class="title-h2">{{ 'Related discussions'|translate }}</div>
      <app-latest-news-section
        [showTitle]="false"
        [showShortTitle]="true"
        [data]="pageData()?.discussions || pageData()?.relatedDiscussions || []"
        customDateField="recordedDate"
        [showSeeAllButton]="false"
      ></app-latest-news-section>
    </div>
  }

  @if (pageData() && pageData()?.discussions?.length) {
    <app-horizontal-divider></app-horizontal-divider>
    <div class="related-publications">
      <div class="title-h2">{{ 'Meeting summaries'|translate }}</div>
      <app-latest-news-section
        [showTitle]="false"
        [data]="pageData()?.discussions || pageData()?.relatedDiscussions || []"
        customDateField="recordedDate"
        [showSeeAllButton]="false"
      ></app-latest-news-section>
    </div>
  }

  <ng-container slot="right-section">

    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>

    <app-links-section
      [links]="pageData()?.latestMeetings"
      [title]="'Latest meetings'">
    </app-links-section>

    <app-links-section
      [links]="pageData()?.upcomingMeetings"
      [title]="'Upcoming meetings'">
    </app-links-section>

    <app-links-section
      [links]="pageData()?.upcomingImportantDates"
      [title]="'Upcoming dates'"></app-links-section>

    <app-links-section
      [contentType]="E_CONTENT_TYPE.Standards"
      [links]="pageData()?.relatedImportantDates"
      [relatedId]="pageData()?.id"
      [showSeeAllButton]="contentType() === E_FOLDER_TYPES.Standards "
      [title]="'Related dates'"></app-links-section>

    <app-links-section
      [links]="pageData()?.relatedProjects"
      [contentType]="E_CONTENT_TYPE.Projects"
      [relatedId]="pageData()?.id"
      [title]="'Related projects'"></app-links-section>

    <app-links-section
      [links]="pageData()?.relatedStandards"
      [contentType]="E_CONTENT_TYPE.Standards"
      [relatedId]="pageData()?.id"
      [title]="'Related standards'"></app-links-section>

    <app-links-section
      [links]="pageData()?.relatedResources"
      [contentType]="E_CONTENT_TYPE.Resources"
      [relatedId]="pageData()?.id"
      [title]="'Related resources'"></app-links-section>


  </ng-container>
</app-three-column-template>
